module.exports = __webpack_public_path__ + "img/15.404fe63a.jpg";